import React from 'react';
import { RecipeTimeProps } from '@views/RecipeDetailPage/_RecipeHero';

import useTranslation from '@repo/ui/src/context/Translation/useTranslation';

interface InlineCardProps {
  title: string;
  prepTime: Array<RecipeTimeProps>;
  cookTime: Array<RecipeTimeProps>;
  hardwood: string;
  servingSizeMin: number;
  description: string;
}
const InlineRecipeCardInfo = ({
  servingSizeMin,
  hardwood,
  cookTime,
  prepTime,
}: InlineCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-y-5 md:flex md:flex-row pt-10">
      {!!prepTime.length && (
        <div className="flex flex-col items-center w-full border-r last:border-r-0">
          <p className="tra-text-web-body-m text-left mb-0">{t('recipeContent.prepTimeLabel')}</p>
          <div className="grid grid-flow-col gap-2">
            {prepTime?.map(({ label, value }, i) => (
              <h5 className="tra-text-web-heading-6 text-left" key={i}>
                {value} {label}{' '}
              </h5>
            ))}
          </div>
        </div>
      )}
      {!!cookTime.length && (
        <div className="flex flex-col items-center border-r last:border-r-0 w-full">
          <p className="tra-text-web-body-m text-left mb-0">{t('recipeContent.cookTimeLabel')}</p>
          <div className="grid grid-flow-col gap-2">
            {cookTime?.map(({ label, value }, i) => (
              <h5 className="tra-text-web-heading-6 text-left" key={i}>
                {value} {label}{' '}
              </h5>
            ))}
          </div>
        </div>
      )}
      {servingSizeMin && (
        <div className="flex flex-col items-center border-r last:border-r-0 w-full">
          <p className="tra-text-web-body-m text-left mb-0">
            {t('recipeContent.servesLabel', undefined, { default: 'serves' })}
          </p>
          <h6 className="tra-text-web-heading-6 text-left">{servingSizeMin}</h6>
        </div>
      )}
      {hardwood && (
        <div className="flex flex-col items-center w-full">
          <p className="tra-text-web-body-m text-left mb-0">{t('recipeContent.pelletsLabel')}</p>
          <h6 className="tra-text-web-heading-6">{hardwood}</h6>
        </div>
      )}
    </div>
  );
};

export default InlineRecipeCardInfo;
